interface LoadingBarProps {
  className?: string;
}

export const LoadingBar = ({ className = "" }: LoadingBarProps) => {
  return (
    <div className={`flex gap-2 ${className}`}>
      {[0, 1, 2, 3, 4].map((index) => (
        <div
          key={index}
          className="w-3 h-3 bg-[#76C2C5] rounded-sm"
          style={{
            animation: `brick-loading 1.0s ease-in-out ${index * 0.1}s infinite`
          }}
        />
      ))}
      <style jsx>{`
        @keyframes brick-loading {
          0%, 100% {
            opacity: 0.2;
            transform: scale(0.8);
          }
          50% {
            opacity: 0.7;
            transform: scale(1.1);
          }
        }
      `}</style>
    </div>
  );
};
